// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TF4e","colBig":"styles_colBig__t4_sY","colSmall":"styles_colSmall__29Fv-"};